import React, { useEffect, useState, useLayoutEffect } from "react";
import { Wrapper, UserDetailsSmallScreenWrapper, DesktopInfoWrapper } from "./UserDetails.styled";
import { Row, Col, Spin } from "components/common";
import Avatar from "../../assets/svg/boy-avatar.svg";
import TestImage from "../../assets/images/img-banner.jpeg";
import UserImage from "../../assets/images/avatar-logo-2.png";
import LocationIcon from "../../assets/svg/location.svg";
import UserInfo from "./UserInfo";
import { useHistory } from "react-router";
import { callGetApi, callGetApiWithAuth } from "utils/api";
import UserInfoSm from "./UserInfoSm";

const UserDetails = () => {
  const history = useHistory();
  let a = history.location.pathname;
  let id = a.split("/")[2];
  const [getUser, setGetUser] = useState({});

  const [location, setLocation] = useState([]);
  const [address, setAddress] = useState({});
  const [accessLevel, setAccessLevel] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const getApiLocation = (userdata) => {
    callGetApi("/location", (data) => {
      let addrs = data?.find((el) => el?._id.toString() === userdata?.locationId);
      setAddress(addrs)
      setLocation(data);
      setIsLoading(false);
    }, (err) => {
      console.log(err);
      setIsLoading(false);
    });
  }
  const getApiRoles = () => {
    callGetApi(
      "/roles",
      (data) => {
        setAccessLevel(data);
      },
      (err) => {
        console.log(err);
      }
    );
  }
  const getUserDetail = () => {
    callGetApi(`/user/${id}`, (data) => {
      setGetUser(data);
      getApiLocation(data);
    }, (err) => {
      console.log(err);
    });
  };
  const getApi = () => {
    setIsLoading(true);
    getApiRoles();
    getUserDetail();
  };

  useEffect(() => {
    getApi();
  }, []);
  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth < 900) {
        setIsSmallScreen(true);
      } else {
        return setIsSmallScreen(false);
      }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return (
    <Wrapper>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 20,
          }}
        >
          <Spin />
        </div>
      ) : (
        <>
          {isSmallScreen ? (
            <UserDetailsSmallScreenWrapper>
              <div className="top-bg-image"></div>
              <div className="user-details-container">
                <div className="floating-details">
                  <div className="img-container">
                    {getUser?.profilePicture ? (
                      <img src={getUser?.profilePicture} alt="User Image" />
                    ) : (
                      <img src={Avatar} alt="User Image" />
                    )}
                  </div>
                  <div className="username">{getUser?.username}</div>
                </div>
                <UserInfoSm
                  data={getUser}
                  accessLevel={accessLevel}
                  location={location}
                  id={id}
                  setGetUser={setGetUser}
                  getUserDetail={getUserDetail}
                />
              </div>
            </UserDetailsSmallScreenWrapper>
          ) : (
            <UserInfo data={getUser} accessLevel={accessLevel} location={location} id={id} setGetUser={setGetUser}
              getUserDetail={getUserDetail} isSmallScreen={isSmallScreen} />
          )}
        </>
      )}
    </Wrapper >
  );
};

export default UserDetails;
